import React, { useCallback } from "react";
import Recipes from "./Recipes";
import { useDispatch, useSelector } from "react-redux";
import { isLibraryShowPurchasedRecipes, isLibraryShowSavedRecipes } from "../../../store/libraryReducer";
import { getRecipes, getRecipesFilterName, isRecipesLoading } from "../../../store/recipesReducer/recipesSelectors";
import {
  setOwnRecipes,
  setPurchasedRecipes,
  setSavedRecipes,
  setUserRecipes,
} from "../../../store/recipesReducer/recipesActions";
import { setRecipesSorting, setRecipesFilter, setRecipesPage } from "store/recipesReducer";
import { recipesFilterOptions, recipesTextTabs } from "../../../shared/FiltersMenu/filtersValues";
import { pagesName } from "../../../variables/recipesVariables";
import { getUser } from "store/userReducer/userSelectors";

export const RecipesContext = ({ page }) => {
  const dispatch = useDispatch();
  const { id } = useSelector(getUser);

  const isLibraryShowSaved = useSelector(isLibraryShowSavedRecipes);
  const isLibraryShowPurchased = useSelector(isLibraryShowPurchasedRecipes);

  const _isRecipesLoading = useSelector(isRecipesLoading);
  const recipes = useSelector(getRecipes);
  const activeFilterOption = useSelector(getRecipesFilterName);

  const requestRecipePage = useCallback(
    (pagination) => {
      setRecipesPage(pagination);
      if (page === pagesName.library && isLibraryShowSaved) dispatch(setSavedRecipes(pagination));
      if (page === pagesName.library && isLibraryShowPurchased) dispatch(setPurchasedRecipes(pagination));
      if (page === pagesName.users) dispatch(setUserRecipes({ id, page: pagination }));
      if (page === pagesName.manager) dispatch(setOwnRecipes(pagination));
    },
    [isLibraryShowSaved, isLibraryShowPurchased, id]
  );

  const resetPagination = useCallback(() => {
    dispatch(setRecipesPage(1));
  }, []);

  const sortByAlphabet = useCallback((sort) => {
    dispatch(setRecipesSorting({ type: "orderByTitle", value: sort }));
  }, []);

  const sortByTime = useCallback((sort) => {
    dispatch(setRecipesSorting({ type: "orderByTime", value: sort }));
  }, []);

  const recipesProps = {};

  if (page === pagesName.library && isLibraryShowSaved) {
    const updateItems = () => {
      dispatch(setSavedRecipes());
    };

    const setFilter = (option) => {
      dispatch(setRecipesFilter(option));
    };

    const libraryFilterSettings = {
      isDisable: _isRecipesLoading,
      updateItems,
      setFilter,
      activeFilterOption,
      filterOptions: recipesFilterOptions,
      filterText: recipesTextTabs,
      onFilterChanging: resetPagination,
    };

    recipesProps.filter = libraryFilterSettings;
    recipesProps.isFilterShow = true;
    recipesProps.isSortingShow = true;
    recipesProps.sortingSettings = {
      sortByTime,
      sortByAlphabet,
      isDisabled: _isRecipesLoading,
    };
  } else if (page === pagesName.manager) {
    const updateItems = useCallback(() => {
      dispatch(setOwnRecipes());
    }, []);

    const setFilter = useCallback((option) => {
      dispatch(setRecipesFilter(option));
    }, []);

    const managerFilterSettings = {
      isDisable: _isRecipesLoading,
      updateItems,
      setFilter,
      activeFilterOption,
      filterOptions: recipesFilterOptions,
      filterText: recipesTextTabs,
      onFilterChanging: resetPagination,
    };

    recipesProps.filter = managerFilterSettings;
    recipesProps.isAddRecipeShow = true;
    recipesProps.isFilterShow = true;
    recipesProps.isSortingShow = true;
    recipesProps.sortingSettings = {
      sortByTime,
      sortByAlphabet,
      isDisabled: _isRecipesLoading,
    };
  }

  return (
    <Recipes
      isUsers={page == "users"}
      isManager={page === pagesName.manager}
      recipes={recipes}
      isLoading={_isRecipesLoading}
      requestPage={requestRecipePage}
      {...recipesProps}
    />
  );
};
